import { CustomChainData } from "@tria-sdk/core";

export function isCustomChain(
  chain: string | CustomChainData
): chain is CustomChainData {
  return typeof chain === "object" && chain !== null && "chainName" in chain;
}
